export const BUDGET_GAME_STATES = {
  initializing: "initializing",
  initialized: "initialized",
  creatingPlan: "creatingPlan",
  planCreationFailed: "planCreationFailed",
  calculator: "calculator",
  budgeting: "budgeting",
  complete: "complete",
};

export const PLAN_CREATION_FAILURE_REASONS = {
  lightcastNoData: "lightcast_no_data",
  invalidInput: "invalid_input",
  unknown: "unknown",
};

export const initialContext = {
  budgetPlan: undefined,
  budgetPlanLoaded: false,
  budgetCategories: {},
  budgetCategoriesLoaded: false,
  currentBudgetCategory: undefined,
  currentSlideIndex: 0,
  isFetchingBudgetPlan: true,
  isTakeHomePayCalculated: false,
  regionalIncomeTaxRate: undefined,
  slideConfigs: [],
  totalSlides: 0,
  planCreationError: undefined,
};
